/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GetEnumWeightsRequest = core.serialization.object({
    sourceField: core.serialization.string(),
    sourceValues: core.serialization.list(core.serialization.string()),
    destinationField: core.serialization.string(),
    destinationValues: core.serialization.list(core.serialization.string()),
});
